"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGridToggleableContext = exports.GridToggleableContext = void 0;
const react_1 = __importStar(require("react"));
const computeRowWidth_1 = __importDefault(require("../utils/computeRowWidth"));
const GridProvider_1 = require("./GridProvider");
exports.GridToggleableContext = (0, react_1.createContext)({
    hiddenColumns: [],
    visibleColumns: [],
    setHiddenColumns: () => { },
    onColumnToggle: () => { },
    rowWidth: 0
});
const useGridToggleableContext = () => (0, react_1.useContext)(exports.GridToggleableContext);
exports.useGridToggleableContext = useGridToggleableContext;
class GridToggleable extends react_1.default.Component {
    constructor(props, context) {
        super(props);
        const { state: { columns } } = context;
        this.state = {
            hiddenColumns: columns.filter((col) => col.props.hidden).map((col) => col.key)
        };
        this.setHiddenColumns = this.setHiddenColumns.bind(this);
    }
    setHiddenColumns(hiddenColumns) {
        this.setState({ hiddenColumns });
    }
    render() {
        const { children, onColumnToggle } = this.props;
        const { hiddenColumns } = this.state;
        const { state: { columns, scrollbarWidth, hasVerticalScroll, columnsWidth, layoutWidth } } = this.context;
        const visibleColumns = columns.filter(({ key }) => !hiddenColumns.includes(key));
        const rowWidth = (0, computeRowWidth_1.default)({
            visibleColumns,
            columnsWidth,
            hasVerticalScroll,
            layoutWidth,
            scrollbarWidth
        });
        return (react_1.default.createElement(exports.GridToggleableContext.Provider, { value: {
                hiddenColumns,
                visibleColumns,
                setHiddenColumns: (hiddenColumns) => {
                    this.setHiddenColumns(hiddenColumns);
                },
                onColumnToggle: (currentColumn) => {
                    onColumnToggle === null || onColumnToggle === void 0 ? void 0 : onColumnToggle(currentColumn);
                },
                rowWidth
            } }, children));
    }
}
GridToggleable.contextType = GridProvider_1.GridContext;
exports.default = GridToggleable;
//# sourceMappingURL=GridToggleable.js.map